import React, { useRef, useState, useEffect } from "react";
import "../styles/banner.css";
import video from "../assets/videos/lop-thieu-nhi.mp4";
const Banner = () => {
  const videoRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    video.muted = isMuted;

    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise
        .then(() => setIsPlaying(true))
        .catch(() => setIsPlaying(false));
    }

    const handlePlay = () => setIsPlaying(true);
    const handlePause = () => setIsPlaying(false);

    video.addEventListener("play", handlePlay);
    video.addEventListener("pause", handlePause);

    return () => {
      video.removeEventListener("play", handlePlay);
      video.removeEventListener("pause", handlePause);
    };
  }, [isMuted]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    console.log(isPlaying);
    const handleLoaded = () => {
      video.classList.add("loaded");
    };

    video.addEventListener("loadeddata", handleLoaded);
    return () => {
      video.removeEventListener("loadeddata", handleLoaded);
    };
  }, [isPlaying]);

  const handleTogglePlay = () => {
    const video = videoRef.current;
    if (!video) return;

    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  };

  const handleToggleMute = () => {
    const video = videoRef.current;
    if (!video) return;

    const newMuted = !video.muted;
    video.muted = newMuted;
    setIsMuted(newMuted);
  };

  return (
    <div className="banner-background">
      <div className="banner-wrapper">
        <video
          ref={videoRef}
          className="banner-video"
          autoPlay
          loop
          playsInline
          muted={isMuted}
          onClick={handleTogglePlay}
        >
          <source
            src={video}
            type="video/mp4"
          />
          Trình duyệt của bạn không hỗ trợ video.
        </video>

        {/* Overlay gradient nếu muốn thêm hiệu ứng overlay mờ */}
        <div className="banner-overlay" />

        <button
          className="mute-toggle-button"
          onClick={handleToggleMute}
          aria-label={isMuted ? "Bật tiếng" : "Tắt tiếng"}
        >
          {isMuted ? "🔇" : "🔊"}
        </button>
      </div>
    </div>
  );
};

export default Banner;
